import { render, staticRenderFns } from "./GlobeIcon.vue?vue&type=template&id=34910d32&scoped=true&"
import script from "./GlobeIcon.vue?vue&type=script&lang=js&"
export * from "./GlobeIcon.vue?vue&type=script&lang=js&"
import style0 from "./GlobeIcon.vue?vue&type=style&index=0&id=34910d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34910d32",
  null
  
)

export default component.exports